import { ROUTE_NAMES_HELP_CENTER_SERVICE_HUBS_NOT_FOUND } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const helpCenterSettingsNotFoundRoute: InvariantRoute = {
	exact: false,
	name: ROUTE_NAMES_HELP_CENTER_SERVICE_HUBS_NOT_FOUND,
	path: '/jira/helpcenter/:any',
};
